export const paymentTypesConstants = {
    PAYMENT_TYPES_LIST_REQUEST: 'PAYMENT_TYPES_LIST_REQUEST',
    PAYMENT_TYPES_LIST_SUCCESS: 'PAYMENT_TYPES_LIST_SUCCESS',
    PAYMENT_TYPES_LIST_ERROR: 'PAYMENT_TYPES_LIST_ERROR',
    PAYMENT_TYPES_SEARCH_REQUEST: 'PAYMENT_TYPES_SEARCH_REQUEST',
};
